import React from 'react';
import { denormaliseFormAddons } from '../../../util/data';
import { FormattedMessage } from '../../../util/reactIntl';
import { FieldTextInput, FieldCheckboxGroup, FieldCheckbox, InlineTextButton } from '../../';

import css from './BookingDatesForm.module.css';
import { validateAddonsQuantity } from '../../../util/validators';

const MIN_SEATS_NUMBER = 1;

const PLUS_SYMBOL = '+';
const MINUS_SYMBOL = '-';

export const AddonsWithQuantity = props => {
  const { addonsFromPublicData, values, formSeats, seats, form, addonsQuantityError } = props;

  const denormalisedAddons = denormaliseFormAddons(addonsFromPublicData);

  const handleQuantityChange = (addonKey, newQuantity) => {
    form.change(`addonsQuantity.${addonKey}`, newQuantity);
  };

  return (
    <div className={css.addonsWithQuantityContainer}>
      <legend>
        <FormattedMessage id="BookingDatesForm.addonsWithQuantityLegend" />
      </legend>
      <ul className={css.addonsWithQuantity}>
        {denormalisedAddons.map(addon => {
          const fieldId = `addons.${addon.key}`;
          const addonQuantity = values?.addonsQuantity?.[addon.key] || MIN_SEATS_NUMBER;
          const isQuantityBelowMinimum = addonQuantity <= MIN_SEATS_NUMBER;
          const isQuantityAboveMaximum = addonQuantity >= formSeats || addonQuantity >= seats;

          const renderIncreaseQuantityButton = (
            <InlineTextButton
              type="button"
              className={css.quantityButton}
              onClick={() =>
                handleQuantityChange(
                  addon.key,
                  Math.max(addonQuantity - MIN_SEATS_NUMBER, MIN_SEATS_NUMBER)
                )
              }
              disabled={isQuantityBelowMinimum}
            >
              {MINUS_SYMBOL}
            </InlineTextButton>
          );

          const renderDecreaseQuantityButton = (
            <InlineTextButton
              type="button"
              className={css.quantityButton}
              onClick={() => handleQuantityChange(addon.key, addonQuantity + MIN_SEATS_NUMBER)}
              disabled={isQuantityAboveMaximum}
            >
              {PLUS_SYMBOL}
            </InlineTextButton>
          );

          return (
            <li className={css.addonsItemWithQuantity} key={fieldId}>
              <FieldCheckbox id={fieldId} name="addons" label={addon.label} value={addon.key} />

              <div className={css.quantity}>
                {renderIncreaseQuantityButton}
                <span className={css.quantityValue}>{addonQuantity}</span>
                <FieldTextInput
                  className={css.quantityInput}
                  id={`addonsQuantity.${addon.key}`}
                  name={`addonsQuantity.${addon.key}`}
                  type="number"
                  defaultValue={MIN_SEATS_NUMBER}
                />
                {renderDecreaseQuantityButton}
              </div>
            </li>
          );
        })}
      </ul>
      {addonsQuantityError && (
        <div className={css.addonsError}>
          <FormattedMessage id="BookingDatesForm.addonsCannotExceedSeats" />
        </div>
      )}
    </div>
  );
};

const Addons = props => {
  const { addonsFromPublicData } = props;

  return (
    <FieldCheckboxGroup
      id="addons"
      name="addons"
      className={css.addons}
      label="Addons"
      options={denormaliseFormAddons(addonsFromPublicData)}
    />
  );
};

export default Addons;
